<cdk-virtual-scroll-viewport
  (scrolledIndexChange)="onScrolledIndexChange($event)"
  [itemSize]="itemHeightInPx"
  class="virtual-scroll-viewport">

  @if (data?.length > 0) {
    @if (!isScrollDataLoading) {
      <ng-container *cdkVirtualFor="let item of data; let i = index; trackBy: trackById">
        <ng-container
          *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: i }">
        </ng-container>
      </ng-container>
    } @else {
      <ng-content select="[scrollLoader]"></ng-content>
    }
  } @else {
    <ng-content select="[noData]"></ng-content>
  }

</cdk-virtual-scroll-viewport>


